import { render, staticRenderFns } from "./qualityRemarkItemValue.vue?vue&type=template&id=ec38fe7c&scoped=true&"
import script from "./qualityRemarkItemValue.vue?vue&type=script&lang=js&"
export * from "./qualityRemarkItemValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec38fe7c",
  null
  
)

export default component.exports